import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Wrench, Zap } from "lucide-react";

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@garajsync.in");
  const [password, setPassword] = useState("GarajSync@2026");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("gs_token", data.token);
      localStorage.setItem("gs_email", data.email);
      toast.success("Welcome back, Admin");
      nav("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left — image with overlay */}
      <div
        className="hidden lg:block relative"
        style={{
          backgroundImage: `linear-gradient(rgba(9,10,11,0.82), rgba(9,10,11,0.92)), url("https://images.unsplash.com/photo-1512457226770-bfa3d6e944b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxtZWNoYW5pYyUyMGdhcmFnZSUyMGluZGlhfGVufDB8fHx8MTc4MjI5NjUxMnww&ixlib=rb-4.1.0&q=85")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 p-12 flex flex-col justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-amber-500 flex items-center justify-center">
              <Wrench className="w-5 h-5 text-black" strokeWidth={2.5} />
            </div>
            <div>
              <div className="font-display font-black text-xl">GarajSync</div>
              <div className="overline">AI Tech Partner</div>
            </div>
          </div>
          <div className="space-y-4">
            <div className="overline text-amber-500">// India's Independent Mechanics</div>
            <h1 className="font-display font-black text-4xl lg:text-5xl tracking-tight leading-tight">
              The WhatsApp-first AI<br />
              tech partner for India's<br />
              <span className="text-amber-500">workshop floor.</span>
            </h1>
            <p className="text-zinc-400 max-w-md leading-relaxed">
              Diagnostics. Voice-note repair logs. Daily learning. Rewards.
              Mechanics never download an app — they chat. You run the platform.
            </p>
          </div>
          <div className="font-mono-data text-xs text-zinc-500">
            v1.0.0 · operations.console
          </div>
        </div>
      </div>

      {/* Right — login form */}
      <div className="flex items-center justify-center p-8 bg-[#090A0B]">
        <form
          onSubmit={submit}
          className="w-full max-w-md space-y-6"
          data-testid="login-form"
        >
          <div className="lg:hidden flex items-center gap-3 mb-4">
            <div className="w-8 h-8 bg-amber-500 flex items-center justify-center">
              <Wrench className="w-4 h-4 text-black" strokeWidth={2.5} />
            </div>
            <div className="font-display font-black text-lg">GarajSync</div>
          </div>

          <div>
            <div className="overline mb-2">// Admin Console</div>
            <h2 className="font-display font-black text-3xl">Sign in</h2>
            <p className="text-zinc-500 text-sm mt-1">Operations dashboard for the GarajSync platform.</p>
          </div>

          <div className="space-y-4">
            <div>
              <label className="overline block mb-2">Email</label>
              <input
                data-testid="login-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[#090A0B] border border-zinc-800 px-3 py-2.5 focus:border-amber-500 focus:ring-0 outline-none text-sm font-mono-data"
                placeholder="admin@garajsync.in"
              />
            </div>
            <div>
              <label className="overline block mb-2">Password</label>
              <input
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-[#090A0B] border border-zinc-800 px-3 py-2.5 focus:border-amber-500 focus:ring-0 outline-none text-sm font-mono-data"
                placeholder="••••••••"
              />
            </div>
          </div>

          <button
            data-testid="login-submit-btn"
            type="submit"
            disabled={loading}
            className="w-full bg-amber-500 hover:bg-amber-600 text-black font-display font-bold uppercase tracking-wider py-3 text-sm flex items-center justify-center gap-2 disabled:opacity-50 transition-colors"
          >
            <Zap className="w-4 h-4" strokeWidth={2.5} />
            {loading ? "Signing in..." : "Sign in to console"}
          </button>

          <div className="text-xs text-zinc-600 font-mono-data border-t border-zinc-900 pt-4">
            seed_admin · admin@garajsync.in / GarajSync@2026
          </div>
        </form>
      </div>
    </div>
  );
}
